import React from "react";
import Select from "../form/select";
import Trash from "../../assets/svg/icons/common/Trash";
import Button from "../new-button";
import useUserStore from "../../stores/user";
import styles from "./SavedFiltersSection.module.scss";

/**
 * Shared "Saved filters" block for v2 filter drawers.
 *
 * Restricted to entity super admins (paymentcloud / ems / kurvpay admins).
 */
function SavedFiltersSection({
  savedFilterOptions,
  selectedSavedFilter,
  onSavedFilterChange,
  onDeleteSavedFilter,
  isDeletingFilter,
  editFilterName,
  onEditFilterNameChange,
  onUpdateSavedFilter,
  isUpdatingFilter,
  showSaveFilterInput,
  onShowSaveInput,
  newFilterName,
  onNewFilterNameChange,
  onSaveFilter,
  isSavingFilter,
  onCancelNewFilter,
  title = "SAVED FILTERS",
}) {
  const isEntitySuperAdmin = useUserStore((state) => state.isEntitySuperAdmin);

  if (!isEntitySuperAdmin) {
    return null;
  }

  return (
    <div className={styles.section}>
      <h6 className={styles.title}>{title}</h6>
      <div className={styles.container}>
        <div className={styles.select_row}>
          <div className={styles.select_wrapper}>
            <Select
              id="saved_filter"
              name="saved_filter"
              options={savedFilterOptions}
              value={selectedSavedFilter}
              onChange={onSavedFilterChange}
              placeholder="Select a saved filter"
              search={savedFilterOptions.length > 5}
            />
          </div>
          {selectedSavedFilter ? (
            <button
              type="button"
              className={styles.delete_btn}
              onClick={(e) =>
                onDeleteSavedFilter(e, parseInt(selectedSavedFilter, 10))
              }
              disabled={
                isDeletingFilter === parseInt(selectedSavedFilter, 10)
              }
              title="Delete this saved filter"
            >
              <Trash color="#CE4343" />
            </button>
          ) : null}
        </div>

        {selectedSavedFilter ? (
          <div className={styles.input_row}>
            <input
              type="text"
              className={styles.input}
              placeholder="Filter name"
              value={editFilterName}
              onChange={(e) => onEditFilterNameChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onUpdateSavedFilter();
                }
              }}
            />
            <Button
              variant="primary"
              size="small"
              onClick={onUpdateSavedFilter}
              disabled={!editFilterName.trim() || isUpdatingFilter}
              isLoading={isUpdatingFilter}
            >
              Update
            </Button>
          </div>
        ) : null}

        {!showSaveFilterInput ? (
          <button
            type="button"
            className={styles.save_link}
            onClick={() => onShowSaveInput(true)}
          >
            + Save current filter
          </button>
        ) : (
          <div className={styles.input_row}>
            <input
              type="text"
              className={styles.input}
              placeholder="Filter name"
              value={newFilterName}
              onChange={(e) => onNewFilterNameChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onSaveFilter();
                }
              }}
              autoFocus
            />
            <Button
              variant="primary"
              size="small"
              onClick={onSaveFilter}
              disabled={!newFilterName.trim() || isSavingFilter}
              isLoading={isSavingFilter}
            >
              Save
            </Button>
            <Button
              variant="secondary"
              size="small"
              onClick={onCancelNewFilter}
            >
              Cancel
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

export default SavedFiltersSection;
